/**
 * mainContent
 */

import lottie from 'lottie-web/build/player/lottie_light'

export module MainContentModule {
  export class Service {
    constructor() {
      document.addEventListener('readCompleteAction', () => {
        Service.setEvent();
      })
    }

    public static setEvent() {
      const $lottieElements = document.querySelectorAll<HTMLElement>('.mainContent__sectionLottie')
      $lottieElements.forEach($lottieElement => {
        const $parent = $lottieElement.closest('.mainContent__section')
        const $path = $lottieElement.getAttribute('data-lottie')
        if ($parent && $path) {
          const $lottieObj = lottie.loadAnimation({
            container: $lottieElement,
            renderer: 'svg',
            loop: false,
            autoplay: false,
            path: $path
          })

          $parent.addEventListener('js__scroll--inCustom', () => {
            if (!$lottieElement.classList.contains('isPlay')) {
              $lottieElement.classList.add('isPlay')
              $lottieObj.play()
            }
          })
        }
      })
    }

  }
}
//js__scroll--fixCustom